/* NG cart guard: if the cart ends up with 2+ copies of the same book, ask once whether that was intended. */
(function () {
  if (window.__ngCartGuard) return; window.__ngCartGuard = true;
  var SKIP = /answer sheet/i;            // packs that are often bought in multiples
  var asked = {};
  try { asked = JSON.parse(sessionStorage.getItem('ngQtyAsked') || '{}'); } catch (e) {}
  function remember(k) { asked[k] = 1; try { sessionStorage.setItem('ngQtyAsked', JSON.stringify(asked)); } catch (e) {} }

  var css = '.ng-qg{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(19,35,58,.55)}' +
    '.ng-qg__box{background:#fff;color:#13233A;border-radius:18px;max-width:400px;width:100%;padding:24px 22px 20px;box-shadow:0 30px 80px rgba(0,0,0,.35);font-family:Mukta,system-ui,sans-serif;text-align:center;animation:ngqg .18s ease}' +
    '@keyframes ngqg{from{transform:translateY(10px);opacity:0}to{transform:none;opacity:1}}' +
    '.ng-qg__img{width:72px;height:auto;border-radius:6px;box-shadow:0 6px 18px rgba(19,35,58,.18);margin:0 auto 12px;display:block}' +
    '.ng-qg h3{font-family:"Bricolage Grotesque",Mukta,sans-serif;font-size:21px;line-height:1.2;margin:0 0 8px}' +
    '.ng-qg p{font-size:15px;line-height:1.45;color:#4A5568;margin:0 0 18px}' +
    '.ng-qg__row{display:flex;gap:10px}.ng-qg__row button{flex:1;border-radius:12px;padding:13px 10px;font-weight:700;font-size:15px;cursor:pointer;font-family:inherit}' +
    '.ng-qg__no{background:#135C99;color:#fff;border:0}.ng-qg__yes{background:#fff;color:#13233A;border:2px solid #CBD3DD}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function ask(item) {
    return new Promise(function (resolve) {
      var w = document.createElement('div'); w.className = 'ng-qg'; w.setAttribute('role', 'dialog'); w.setAttribute('aria-modal', 'true');
      var title = (item.product_title || item.title || 'this book').replace(/ 2026-27| 2027/g, '');
      var combo = item.variant_title && !/default/i.test(item.variant_title) ? ' (' + item.variant_title + ')' : '';
      w.innerHTML = '<div class="ng-qg__box">' +
        (item.image ? '<img class="ng-qg__img" src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '') +
        '<h3>' + item.quantity + ' copies of the same book?</h3>' +
        '<p>Your cart has <b>' + item.quantity + ' × ' + title + combo + '</b>. Did you want ' + item.quantity + ' copies?</p>' +
        '<div class="ng-qg__row"><button type="button" class="ng-qg__no">No, keep 1</button><button type="button" class="ng-qg__yes">Yes, ' + item.quantity + ' copies</button></div></div>';
      document.body.appendChild(w);
      w.querySelector('.ng-qg__no').focus();
      function done(v) { w.remove(); resolve(v); }
      w.querySelector('.ng-qg__no').onclick = function () { done(false); };
      w.querySelector('.ng-qg__yes').onclick = function () { done(true); };
    });
  }

  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer');
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var dp = new DOMParser();
      if (s['cart-drawer'] && drawer) {
        var html = dp.parseFromString(s['cart-drawer'], 'text/html');
        var ni = html.querySelector('.drawer__inner'), oi = drawer.querySelector('.drawer__inner');
        if (ni && oi) oi.innerHTML = ni.innerHTML;
        var nd = html.querySelector('cart-drawer');
        if (nd) drawer.classList.toggle('is-empty', nd.classList.contains('is-empty'));
      }
      if (s['cart-icon-bubble']) {
        var b = document.getElementById('cart-icon-bubble');
        var nb = dp.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (b && nb) b.innerHTML = nb.innerHTML;
      }
    }).catch(function () { location.reload(); });
  }

  var busy = false;
  function check() {
    if (busy) return; busy = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = (cart.items || []).find(function (i) {
        return i.quantity >= 2 && !SKIP.test(i.product_title || '') && !asked[i.key + ':' + i.quantity];
      });
      if (!item) { busy = false; return; }
      return ask(item).then(function (yes) {
        remember(item.key + ':' + item.quantity);
        if (yes) { busy = false; return; }
        return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 1 }) })
          .then(function () { remember(item.key + ':1'); busy = false; refreshCartUI(); });
      });
    }).catch(function () { busy = false; });
  }

  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(check, 350); }).catch(function () {});
    }
    return p;
  };
})();
